import * as i0 from '@angular/core';
import { Component, Input, NgModule, Directive, HostBinding, HostListener, ViewEncapsulation, ContentChild, ContentChildren } from '@angular/core';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i1 from '@angular/router';
import { RouterModule } from '@angular/router';

const SE_FE_TAB_INTERACTIONS = ['routerLink', 'href'];
const SE_FE_TAB_ACTIVE_CLASS = 'se-fe-tabs__tab--active';
class SeFeTabsComponent {
    constructor(router) {
        this.router = router;
        this.navAriaLabel = 'secondary navigation';
        // noop
    }
    activateTab(tab) {
        this.tabs.filter(tab => tab.active = false);
        if (!tab.target || tab.target === '_self')
            tab.active = true;
    }
    ariaCurrent(tab) {
        return this.isActive(tab) ? 'page' : 'false';
    }
    activeTabClass(tab) {
        return this.isActive(tab) ? SE_FE_TAB_ACTIVE_CLASS : '';
    }
    show(tab, interaction) {
        return interaction === Object.keys(tab).filter(k => SE_FE_TAB_INTERACTIONS.includes(k))[0];
    }
    isActive(tab) {
        if (tab.href) {
            return this.activeHref(tab.href);
        }
        else if (tab.routerLink) {
            return this.activeRouterLink(tab.routerLink);
        }
    }
    activeHref(href) {
        const base = this.router.location._baseHref;
        const baseIndex = href.indexOf(base);
        const stripped = baseIndex === 0 ? href.substring(base.length) : href;
        return this.router.isActive(stripped, false);
    }
    activeRouterLink(routerLink) {
        const urlTree = this.router.createUrlTree([].concat(routerLink));
        return this.router.isActive(urlTree, false);
    }
}
SeFeTabsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeTabsComponent, deps: [{ token: i1.Router }], target: i0.ɵɵFactoryTarget.Component });
SeFeTabsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: SeFeTabsComponent, selector: "se-fe-tabs", inputs: { tabs: ["seFeDataTabs", "tabs"], navAriaLabel: ["seFeDataAriaLabel", "navAriaLabel"] }, ngImport: i0, template: "<nav [attr.aria-label]=\"navAriaLabel\">\n  <ul class=\"se-fe-tabs__wrapper\">\n    <li class=\"se-fe-tabs__tab-list-item\" *ngFor=\"let tab of tabs\">\n      <a\n        *ngIf=\"show(tab, 'href')\"\n        tabindex=\"0\"\n        [attr.aria-current]=\"ariaCurrent(tab)\"\n        class=\"se-fe-tabs__tab se-fe-theme--interactive\"\n        [attr.href]=\"tab.href\"\n        [attr.target]=\"tab.target\"\n        (click)=\"activateTab(tab)\"\n        [ngClass]=\"activeTabClass(tab)\">\n        {{ tab.text }}\n      </a>\n      <a\n        *ngIf=\"show(tab, 'routerLink')\"\n        tabindex=\"0\"\n        [attr.aria-current]=\"ariaCurrent(tab)\"\n        class=\"se-fe-tabs__tab se-fe-theme--interactive\"\n        (click)=\"activateTab(tab)\"\n        [routerLink]=\"tab.routerLink\"\n        [ngClass]=\"activeTabClass(tab)\">\n        {{ tab.text }}\n      </a>\n    </li>\n  </ul>\n</nav>\n", styles: [":host{--shadow-size: .5em;background:linear-gradient(to right,var(--se-bg),var(--se-bg),transparent calc(var(--shadow-size) * 2)),radial-gradient(farthest-side at 0 50%,var(--se-shadow),transparent),linear-gradient(to left,var(--se-bg),var(--se-bg),transparent calc(var(--shadow-size) * 2)),radial-gradient(farthest-side at 100% 50%,var(--se-shadow),transparent) 100%;background-color:var(--se-bg);background-repeat:no-repeat;background-attachment:local,scroll,local,scroll;background-size:100% 100%,var(--shadow-size) 100%,100% 100%,var(--shadow-size) 100%}.se-fe-tabs__tab--active:after{content:\"\";width:100%;position:absolute;bottom:-4px;left:0;height:4px}:host{display:flex;overflow-x:auto;overflow-y:hidden;padding:0 var(--se-tab-spacing, 18px);white-space:nowrap}.se-fe-tabs__wrapper{display:flex;flex:0 0 auto;list-style-type:none;margin:4px;padding:0;white-space:nowrap}.se-fe-tabs__tab{--se-interactive-bg: transparent;border-radius:4px;color:var(--se-accent)!important;display:flex;flex-direction:column;font:var(--se-control-font);margin:0 3px;mix-blend-mode:var(--se-accent-blend-mode);padding:10px 6px;position:relative;text-decoration:none}.se-fe-tabs__tab--active{color:color-mix(in srgb,var(--se-accent),var(--se-text) var(--se-active-text-mix))!important}.se-fe-tabs__tab--active:after{background-color:color-mix(in srgb,var(--se-accent),var(--se-text) var(--se-active-text-mix))!important}\n"], directives: [{ type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i1.RouterLinkWithHref, selector: "a[routerLink],area[routerLink]", inputs: ["routerLink", "target", "queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "relativeTo"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeTabsComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'se-fe-tabs',
                    templateUrl: './se-fe-tabs.component.html',
                    styleUrls: ['./se-fe-tabs.component.scss'],
                }]
        }], ctorParameters: function () { return [{ type: i1.Router }]; }, propDecorators: { tabs: [{
                type: Input,
                args: ['seFeDataTabs']
            }], navAriaLabel: [{
                type: Input,
                args: ['seFeDataAriaLabel']
            }] } });

class SeFeTabsModule {
}
SeFeTabsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeTabsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SeFeTabsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeTabsModule, declarations: [SeFeTabsComponent], imports: [CommonModule, RouterModule], exports: [SeFeTabsComponent] });
SeFeTabsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeTabsModule, imports: [[CommonModule, RouterModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeTabsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [SeFeTabsComponent],
                    imports: [CommonModule, RouterModule],
                    exports: [SeFeTabsComponent],
                }]
        }] });

class SeFeTabDirective {
    constructor(el) {
        this.el = el;
        this.baseClass = true;
        this.interactiveClass = true;
        this.index = '0';
        this.active = false;
        //noop
    }
    get ariaCurrent() {
        return this.active ? 'page' : 'false';
    }
    onClick() { this.active = true; }
    onKeydown(event) {
        const key = event.key;
        if (key === 'Enter' || key === 'Space') {
            this.active = true;
        }
    }
    get element() {
        return this.el.nativeElement;
    }
}
SeFeTabDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeTabDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
SeFeTabDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.17", type: SeFeTabDirective, selector: "[seFeTab]", inputs: { active: ["seFeTab", "active"] }, host: { listeners: { "click": "onClick()", "keydown": "onKeydown($event)" }, properties: { "class.se-fe-tab-group__tab": "this.baseClass", "class.se-fe-theme--interactive": "this.interactiveClass", "attr.aria-current": "this.ariaCurrent", "attr.tabindex": "this.index", "class.se-fe-tab-group__tab--active": "this.active" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeTabDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[seFeTab]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { baseClass: [{
                type: HostBinding,
                args: ['class.se-fe-tab-group__tab']
            }], interactiveClass: [{
                type: HostBinding,
                args: ['class.se-fe-theme--interactive']
            }], ariaCurrent: [{
                type: HostBinding,
                args: ['attr.aria-current']
            }], index: [{
                type: HostBinding,
                args: ['attr.tabindex']
            }], active: [{
                type: Input,
                args: ['seFeTab']
            }, {
                type: HostBinding,
                args: ['class.se-fe-tab-group__tab--active']
            }], onClick: [{
                type: HostListener,
                args: ['click']
            }], onKeydown: [{
                type: HostListener,
                args: ['keydown', ['$event']]
            }] } });

class SeFeTabItemComponent {
    constructor(el) {
        this.el = el;
        this.role = 'list-item';
        this.baseClass = true;
        //noop
    }
    get element() {
        return this.el.nativeElement;
    }
}
SeFeTabItemComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeTabItemComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
SeFeTabItemComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: SeFeTabItemComponent, selector: "se-fe-tab-item", host: { properties: { "attr.role": "this.role", "class.se-fe-tab-group__tab-list-item": "this.baseClass" } }, queries: [{ propertyName: "tabLink", first: true, predicate: SeFeTabDirective, descendants: true }], ngImport: i0, template: `<ng-content></ng-content>`, isInline: true, styles: [".se-fe-tab-group__tab--active:after{content:\"\";width:100%;position:absolute;bottom:-4px;left:0;height:4px}.se-fe-tab-group__tab{align-items:center;color:var(--se-accent)!important;border-radius:4px;padding:0 12px;height:48px;margin:0;mix-blend-mode:var(--se-accent-blend-mode);display:flex;position:relative;font:var(--se-control-font);text-decoration:none}.se-fe-tab-group__tab--active{border-bottom-left-radius:0;border-bottom-right-radius:0;color:color-mix(in srgb,var(--se-accent),var(--se-text) var(--se-active-text-mix))!important}.se-fe-tab-group__tab--active:after{color:var(--se-accent)!important;background-color:color-mix(in srgb,var(--se-accent),var(--se-text) var(--se-active-text-mix))!important}\n"], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeTabItemComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'se-fe-tab-item',
                    template: `<ng-content></ng-content>`,
                    styleUrls: ['./se-fe-tab-item.component.scss'],
                    encapsulation: ViewEncapsulation.None
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { role: [{
                type: HostBinding,
                args: ['attr.role']
            }], baseClass: [{
                type: HostBinding,
                args: ['class.se-fe-tab-group__tab-list-item']
            }], tabLink: [{
                type: ContentChild,
                args: [SeFeTabDirective]
            }] } });

class SeFeTabGroupComponent {
    constructor() {
        this.role = 'navigation';
        this.seFeDataAriaLabel = 'secondary navigation';
    }
    onClick(event) {
        this.updateActiveTab(event);
    }
    onKeydown(event) {
        const key = event.code;
        if (key === 'Enter' || key === 'Space')
            this.updateActiveTab(event);
    }
    updateActiveTab(event) {
        if (!this.tabItem)
            return;
        const target = event.target;
        const path = event.composedPath();
        path.forEach(el => {
            if (!(el === null || el === void 0 ? void 0 : el.matches))
                return;
            if (el.matches('.se-fe-tab-group__tab-list-item')) {
                this.tabItem.forEach(item => {
                    item.tabLink.active = false;
                    if (item.element.contains(target))
                        item.tabLink.active = true;
                });
            }
        });
    }
}
SeFeTabGroupComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeTabGroupComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
SeFeTabGroupComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: SeFeTabGroupComponent, selector: "se-fe-tab-group", inputs: { seFeDataAriaLabel: "seFeDataAriaLabel" }, host: { listeners: { "click": "onClick($event)", "keydown": "onKeydown($event)" }, properties: { "attr.role": "this.role", "attr.aria-label": "this.seFeDataAriaLabel" } }, queries: [{ propertyName: "tabItem", predicate: SeFeTabItemComponent }], ngImport: i0, template: "<ul class=\"se-fe-tab-group__wrapper\">\n  <ng-content></ng-content>\n</ul>\n", styles: [":host{--shadow-size: .5em;background:linear-gradient(to right,var(--se-bg),var(--se-bg),transparent calc(var(--shadow-size) * 2)),radial-gradient(farthest-side at 0 50%,var(--se-shadow),transparent),linear-gradient(to left,var(--se-bg),var(--se-bg),transparent calc(var(--shadow-size) * 2)),radial-gradient(farthest-side at 100% 50%,var(--se-shadow),transparent) 100%;background-color:var(--se-bg);background-repeat:no-repeat;background-attachment:local,scroll,local,scroll;background-size:100% 100%,var(--shadow-size) 100%,100% 100%,var(--shadow-size) 100%}:host{display:flex;overflow-x:auto;overflow-y:hidden;padding:0 var(--se-tab-spacing, 0);white-space:nowrap}.se-fe-tab-group__wrapper{display:flex;flex:0 0 auto;margin:4px;padding:0;white-space:nowrap;list-style-type:none}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeTabGroupComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'se-fe-tab-group',
                    templateUrl: './se-fe-tab-group.component.html',
                    styleUrls: ['./se-fe-tab-group.component.scss'],
                }]
        }], propDecorators: { role: [{
                type: HostBinding,
                args: ['attr.role']
            }], seFeDataAriaLabel: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['attr.aria-label']
            }], tabItem: [{
                type: ContentChildren,
                args: [SeFeTabItemComponent]
            }], onClick: [{
                type: HostListener,
                args: ['click', ['$event']]
            }], onKeydown: [{
                type: HostListener,
                args: ['keydown', ['$event']]
            }] } });

class SeFeTabGroupModule {
}
SeFeTabGroupModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeTabGroupModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SeFeTabGroupModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeTabGroupModule, declarations: [SeFeTabGroupComponent, SeFeTabItemComponent, SeFeTabDirective], imports: [CommonModule], exports: [SeFeTabGroupComponent, SeFeTabItemComponent, SeFeTabDirective] });
SeFeTabGroupModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeTabGroupModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeTabGroupModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [SeFeTabGroupComponent, SeFeTabItemComponent, SeFeTabDirective],
                    imports: [CommonModule],
                    exports: [SeFeTabGroupComponent, SeFeTabItemComponent, SeFeTabDirective],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { SeFeTabDirective, SeFeTabGroupComponent, SeFeTabGroupModule, SeFeTabItemComponent, SeFeTabsComponent, SeFeTabsModule };
